import { useTranslation } from 'react-i18next';
import { useLogger, useUserContext } from '@vp/ubik-context';
import { App } from '../app';
import { sanitiseLocale } from '../app/i18n/config';
import LogoInspirationPage from '../app/pages/LogoInspirationPage';
import { DefaultPageTrackingParams } from '../app/utils/analytics';
import { logoInspirationBasePath } from '../app/utils/urls';
import type { Logger } from '@vp/ubik-logging';
import type { Translation } from '../@types/resources';
import type { RelatedKeywordData } from '../app/pages/LogoInspirationPage/components/RelatedIdeas/RelatedIdeas';
import type { KeywordData } from '../app/pages/LogoInspirationPage/content';
import type { Design } from '../app/pages/LogoInspirationPage/content/logo-inspiration';
import type { BlogPost } from '../app/utils/blog';
import type { EnvironmentContextType } from '../app/utils/environmentContext';

export interface Props {
    translation: Translation;
    keywordData?: KeywordData;
    relatedKeywords: RelatedKeywordData[];
    designs: Design[];
    envContext: EnvironmentContextType;
    blogPosts: BlogPost[];
}

const defaultPageTrackingParams: DefaultPageTrackingParams = {
    route: logoInspirationBasePath,
};

export const Fragment = ({
    translation,
    keywordData,
    relatedKeywords,
    designs,
    envContext,
    blogPosts,
}: Props) => {
    const logger: Logger = useLogger();
    const { i18n } = useTranslation();
    const locale = sanitiseLocale(useUserContext().locale);

    logger.info(`Rendering Logo inspiration fragment for the locale ${locale}`);

    i18n.addResourceBundle(locale, 'translation', translation).changeLanguage(locale);

    return (
        <App
            defaultPageTrackingParams={defaultPageTrackingParams}
            locale={locale}
            envContext={envContext}
        >
            <LogoInspirationPage
                keywordData={keywordData}
                relatedKeywords={relatedKeywords}
                designs={designs}
                blogPosts={blogPosts}
            />
        </App>
    );
};
